import { createSelector } from 'reselect';
import { DelayCollectionModel } from '../../Model/DelayListCollection';

type State = any;

// Selectors for raw state slices
const maintDelaysStateSelector = (state: State) => state.maintDelaysState;
const fltopsDelaysStateSelector = (state: State) => state.fltopsDelaysState;


// Memoized selectors
export const selectMaintList = createSelector(
  [maintDelaysStateSelector],
  (maintDelaysState) => maintDelaysState.maintDelaysList
);

export const selectFltopsList = createSelector(
  [fltopsDelaysStateSelector],
  (fltopsDelaysState) => fltopsDelaysState.fltopsDelaysList
);

// Optionally, selectors for loading/error
export const selectMaintListLoading = createSelector(
  [maintDelaysStateSelector],
  (maintDelaysState) => maintDelaysState.loading
);

export const selectFltopsListLoading = createSelector(
  [fltopsDelaysStateSelector],
  (fltopsDelaysState) => fltopsDelaysState.loading
);

export const selectMaintListError = createSelector(
  [maintDelaysStateSelector],
  (maintDelaysState) => maintDelaysState.error
);

export const selectFltopsListError = createSelector(
  [fltopsDelaysStateSelector],
  (fltopsDelaysState) => fltopsDelaysState.error
);
